var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.673 13.361l-1.4 1.429a2.067 2.067 0 002.92 2.919l3.246-3.238a2.084 2.084 0 000-2.928 1.145 1.145 0 011.619-1.619 4.374 4.374 0 010 6.165l-3.246 3.248a4.36 4.36 0 11-6.165-6.165l2.454-2.455a6.3 6.3 0 00.572 2.644zm5.451-8.7L9.908 7.91a4.374 4.374 0 000 6.165 1.145 1.145 0 001.619-1.619 2.084 2.084 0 010-2.928l3.246-3.238a2.067 2.067 0 012.919 2.92l-1.4 1.438a6.028 6.028 0 01.594 2.652l2.471-2.471a4.36 4.36 0 00-6.165-6.165z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15152",
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default SvgLinkIcon;